import { combineEpics } from 'redux-observable';

import { getClientSOCartEpic } from './getClientSOCartEpic';
import { getLatestSOCartEpic } from './getLatestSOCartEpic';
import { getSOCartPagingEpic } from './getSOCartPagingEpic';

const personalizeOfferEpic = combineEpics(getLatestSOCartEpic, getSOCartPagingEpic, getClientSOCartEpic);

export default personalizeOfferEpic;
